module.exports = __webpack_public_path__ + "static/qrcode-line.d7aaaf46.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/qrcode-line.png
// module id = 1034
// module chunks = 2